import reducer from './debts.reducer';
import * as action from './debts.action';
import * as selector from './debts.selector';
import * as constant from './debts.constant';
import initialState from './debts.initialState';
import saga from './debts.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  saga,
  name: constant.NAME,
};
